import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@/shared/services/auth.service';
import { AccountStatus } from '@/shared/models/company';
import { UserRole } from '@/shared/models/user';

@Injectable({
  providedIn: 'root',
})
export class DefaultRouteGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(): boolean {
    const user = this.authService.user;

    if (!user) {
      this.router.navigate(['/login']);
      return false;
    }

    const accountStatus = user.company?.accountStatus;
    const isAdmin = user.role === UserRole.admin;

    // Disabled accounts are handled by InactiveAccountGuard - this shouldn't be reached
    // But for safety, redirect to login
    if (accountStatus === AccountStatus.Disabled) {
      this.router.navigate(['/login']);
      return false;
    }

    // Redirect inactive ADMIN users to Get Started page
    if (isAdmin && accountStatus === AccountStatus.Inactive) {
      this.router.navigate(['/get-started']);
      return false;
    }

    // Redirect pending ADMIN users to Get Started page (default landing)
    if (isAdmin && accountStatus === AccountStatus.Pending) {
      this.router.navigate(['/get-started']);
      return false;
    }

    // CRAT-975 — a Lister only has the inventory create/edit area; land them on their main page.
    if (user.role === UserRole.lister) {
      this.router.navigate(['/inventory/search-products']);
      return false;
    }

    // For all other cases (Active/undefined status, non-admin users), redirect to dashboard
    this.router.navigate(['/dashboard']);
    return false;
  }
}
